var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "labs-list",
    _vm._b(
      {
        attrs: { renderless: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var userLabs = ref.userLabs
              var getEquipments = ref.getEquipments
              var getForWho = ref.getForWho
              return [
                _c("div", { staticClass: "catalog-labs-slider" }, [
                  _c(
                    "div",
                    {
                      class:
                        "catalog-labs-slider__inner " +
                        (_vm.catalogLoading ? "loader loader--dark" : "")
                    },
                    [
                      userLabs.length > 1
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowElement,
                                  expression: "isShowElement"
                                }
                              ],
                              staticClass: "catalog-labs-slider__buttons"
                            },
                            [
                              _c(
                                "button",
                                {
                                  ref: "prevBtn",
                                  staticClass:
                                    "slider-nav-btn slider-nav-btn--dark slider-nav-btn--small slider-nav-btn--prev js-lab-prev-slide",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.prevDisabled
                                  }
                                },
                                [
                                  _vm._v(
                                    "Предыдущий слайд\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  ref: "nextBtn",
                                  staticClass:
                                    "slider-nav-btn slider-nav-btn--dark slider-nav-btn--small js-lab-next-slide",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.nextDisabled
                                  }
                                },
                                [
                                  _vm._v(
                                    "Следующий слайд\n                    "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "catalog-labs-slider__items" }, [
                        _c(
                          "div",
                          { ref: "slider", staticClass: "swiper-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "swiper-wrapper" },
                              _vm._l(userLabs, function(lab, index) {
                                return _c(
                                  "div",
                                  {
                                    key: lab.ID,
                                    staticClass:
                                      "catalog-labs-slider__slide swiper-slide",
                                    attrs: {
                                      "data-filter-query":
                                        lab.LAB_FILTER_COFFEE_QUERY,
                                      "data-brew-value":
                                        lab.LAB_FILTER_COFFEE.brew || null,
                                      "data-slider-index": index
                                    }
                                  },
                                  [
                                    _c("lab-card", {
                                      attrs: {
                                        renderless: "",
                                        lab: lab,
                                        equipments: getEquipments(
                                          lab.UF_COOKING_TYPE.ID
                                        ),
                                        "for-who": getForWho(lab.UF_FOR.ID)
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var labName = ref.labName
                                              var labPlace = ref.labPlace
                                              var rating = ref.rating
                                              var equipmentSlots =
                                                ref.equipmentSlots
                                              var getEquipmentRating =
                                                ref.getEquipmentRating
                                              var checkEquipment =
                                                ref.checkEquipment
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      "lab-slide " +
                                                      (index ===
                                                      _vm.currentSlideIndex
                                                        ? ""
                                                        : "lab-slide--inactive") +
                                                      " " +
                                                      (userLabs.length === 1
                                                        ? "lab-slide--single"
                                                        : "") +
                                                      " " +
                                                      (!_vm.labFilterActive
                                                        ? "lab-slide--disabled"
                                                        : "")
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "lab-slide__header"
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "lab-slide__name"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "lab-slide__name-main"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    labName
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "lab-slide__name-separate"
                                                              },
                                                              [_vm._v("/")]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.isShowElement
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "lab-slide__name-type"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Кофе-лаборатория"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "lab-slide__tag"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "lab-tag"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    labPlace
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isShowElement
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "lab-slide__rating"
                                                              },
                                                              [
                                                                _c(
                                                                  "rating-stars",
                                                                  {
                                                                    attrs: {
                                                                      rating: rating
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "lab-slide__tune"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "btn btn-block btn-main btn-sm",
                                                                attrs: {
                                                                  href:
                                                                    _vm.recommendLink +
                                                                    "#profile-recomm"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Улучшить"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "svg",
                                                          {
                                                            staticClass:
                                                              "lab-slide__chevron-adaptive",
                                                            class: {
                                                              "lab-slide__chevron-adaptive--open":
                                                                _vm.isOpen
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.toggleAdaptiveSpoiler
                                                            }
                                                          },
                                                          [
                                                            _c("use", {
                                                              attrs: {
                                                                "xlink:href":
                                                                  "/sprite.svg#icon-chevron-collapse"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "lab-slide__equipment"
                                                      },
                                                      _vm._l(
                                                        equipmentSlots,
                                                        function(equipment) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: equipment.ID,
                                                              staticClass:
                                                                "lab-slide-card lab-slide__card"
                                                            },
                                                            [
                                                              _c(
                                                                "lab-card-equipment",
                                                                {
                                                                  attrs: {
                                                                    "for-who-id":
                                                                      lab.UF_FOR
                                                                        .ID,
                                                                    "cooking-type-id":
                                                                      lab
                                                                        .UF_COOKING_TYPE
                                                                        .ID,
                                                                    "equipment-slot": equipment,
                                                                    "equipment-selected": checkEquipment(
                                                                      equipment
                                                                    ),
                                                                    modifier:
                                                                      "filter"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isShowElement
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "lab-slide__handlers-adaptive"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "lab-slide__tune"
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-block btn-main btn-sm",
                                                                    attrs: {
                                                                      href:
                                                                        _vm.recommendLink +
                                                                        "#profile-recomm"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Улучшить лабораторию"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "transition",
                                                      {
                                                        attrs: {
                                                          name: "lab-slide-note"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "lab-slide__note"
                                                          },
                                                          [
                                                            !_vm.catalogLoading
                                                              ? [
                                                                  _vm.labFilterActive
                                                                    ? [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "Сейчас вы видите кофе, идеально подходящий для этой кофе-лаборатории"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "lab-slide__reset",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Сбросить фильтр"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                return _vm.resetFilter(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "svg",
                                                                              {
                                                                                attrs: {
                                                                                  width:
                                                                                    "24",
                                                                                  height:
                                                                                    "24"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "use",
                                                                                  {
                                                                                    attrs: {
                                                                                      "xlink:href":
                                                                                        "/sprite.svg#icon-close-nofill"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Сбросить фильтр"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm.filterIsClean ||
                                                                      !_vm.labFilterActive
                                                                    ? [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "Сейчас вы видите кофе, без фильтрации"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "lab-slide__reset",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Сбросить фильтр"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                return _vm.handleFilterForCurrentSlide(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Подобрать кофе для лаборатории"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "Сейчас вы видите кофе, подобранный в соответствии с фильтром"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "lab-slide__reset",
                                                                            attrs: {
                                                                              type:
                                                                                "button",
                                                                              "aria-label":
                                                                                "Сбросить фильтр"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                return _vm.resetFilter(
                                                                                  $event
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Сбросить фильтр"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                ]
                                                              : [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      "Пожалуйста, подождите..."
                                                                    )
                                                                  ])
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", {
                              ref: "pagination",
                              staticClass: "swiper-pagination"
                            })
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            }
          }
        ])
      },
      "labs-list",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }